module.exports = __webpack_public_path__ + "img/coming-soon.1bda75d5.svg";